import { FC, useState } from 'react'

import styled from 'styled-components'

import { TextLink } from 'src/Components/TextLink'
import { useAppSelector } from 'src/Hooks/redux'
import { PrimaryAlert } from 'src/Components/PrimaryAlert'
import { PrimaryDottedButton } from 'src/Components/Buttons/PrimaryDottedButton'
import { useLazySendEmailToConfirmAccountQuery } from 'src/Redux/auth-process/emailApi'
import { getUserEmail } from 'src/Redux/auth-process/userSlice/selectors'

import { CHANGE_EMAIL_LINK } from '../index'

const StyledPrimaryDottedButton = styled(PrimaryDottedButton)`
  padding-left: 0;
  padding-right: 0;
  color: ${({ theme }) => theme.color.darkGrey} !important;
`
const YellowPrimaryDottedButton = styled(StyledPrimaryDottedButton)`
  color: ${({ theme }) => theme.color.mediumOrange} !important;
  & > div {
    border-bottom: 1px dashed ${({ theme }) => theme.color.mediumOrange};
  }
`

const StyledTextLink = styled(TextLink)`
  text-align: center;
  font-family: 'Segoe UI';
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  border-bottom: 1px dashed ${({ theme }) => theme.color.darkGrey};
  color: ${({ theme }) => theme.color.darkGrey} !important;
  & > div {
    border-bottom: 1px dashed ${({ theme }) => theme.color.darkGrey};
  }
  &:hover {
    border-bottom: 1px dashed transparent;
  }
  &:focus-visible {
    outline: none;
  }
`
const DottedButtonWrapper = styled.div`
  display: flex;
  gap: 16px;
  align-items: center;
`

export const DescriptionText = styled.div`
  color: ${({ theme }) => theme.color.mediumOrange};
  font-size: 14px;
  font-weight: 400;
  padding-top: 14px;
  padding-bottom: 10px;
`

export const EmailConfirmationWarning: FC = () => {
  const email = useAppSelector(getUserEmail)
  const [isMailSent, setIsMailSent] = useState(false)
  const [sendEmail, { isLoading }] = useLazySendEmailToConfirmAccountQuery()

  const onSendAgain = (): void => {
    sendEmail().then(() => {
      setIsMailSent(true)
    })
  }

  return (
    <PrimaryAlert
      type='warning'
      hasCross={false}
      title='Email confirmation'
      renderButtons={() => (
        <DottedButtonWrapper>
          {!isMailSent && (
            <StyledTextLink href={CHANGE_EMAIL_LINK}>
              Update email
            </StyledTextLink>
          )}
          {!isMailSent && (
            <YellowPrimaryDottedButton
              disabled={isLoading}
              onClick={onSendAgain}
            >
              Send again
            </YellowPrimaryDottedButton>
          )}
          {isMailSent && <DescriptionText>Email has been sent</DescriptionText>}
        </DottedButtonWrapper>
      )}
    >
      Check your email at {email} and click the confirmation link. If you can't
      access this email, please update it on our platform.
    </PrimaryAlert>
  )
}
